module.exports = __webpack_public_path__ + "img/progress_069.8219d770.png";